module.exports = __webpack_public_path__ + "img/Close.f271cfd9.png";